const formatFraction = (denominator: number, numerator: number) => {
  if (denominator && numerator) {
    const wholeNumber = Math.floor(numerator / denominator)
    const remainder = numerator % denominator

    if (wholeNumber === 0) {
      return (
        <span>
          {numerator}/{denominator}
        </span>
      )
    }

    if (remainder === 0) {
      return <span>{wholeNumber}</span>
    }

    return (
      <span>
        {wholeNumber}
        <sup>
          {remainder}/{denominator}
        </sup>
      </span>
    )
  }

  return <span>0</span>
}

export default formatFraction
